import { useState } from "react";
import InfoPop from "./InfoPop";

export const SEVEN_P = ["People", "Practitioners", "Places", "Passages", "Properties", "Products", "Programmes"];
export const LLL = ["LONGEVITY", "LEISURE", "LIFESTYLE"];
export const P_TABS = ["All", ...SEVEN_P, ...LLL];

const COLL_TAGS = {
  "Datu Wellness": ["Properties", "LONGEVITY"], "Oliveto Estate": ["Properties", "LEISURE"], "Villa Treville": ["Properties", "LEISURE"],
  "39 Monte-Carlo": ["Places", "LIFESTYLE"], "ProLon / Dr Valter Longo": ["People", "Practitioners", "Products", "LONGEVITY"],
  "Travela Wellness": ["Practitioners", "LONGEVITY"], "Mindvalley": ["Programmes", "LIFESTYLE"],
  "LUXEWELL Signature Programmes": ["Programmes", "LONGEVITY", "LEISURE", "LIFESTYLE"],
};
const LLL_RE = {
  LONGEVITY: /clinic|clinical|medical|medi|longevity|integrative/, LEISURE: /resort|hotel|safari|boat|lodge|rail/, LIFESTYLE: /retreat|spa|programme|estate|wellness group|growth/,
};

export const tagsFor = (p) => {
  if (COLL_TAGS[p.name]) return COLL_TAGS[p.name];
  const t = `${p.name} ${p.line}`.toLowerCase();
  const seven = /boat|yacht|rail|aviation/.test(t) ? "Passages" : /programme|program/.test(t) ? "Programmes" : /product|nutrition/.test(t) ? "Products" : "Properties";
  return [seven, ...LLL.filter((k) => LLL_RE[k].test(t))];
};

const chip = (on) => `eyebrow !text-[0.6rem] border px-4 py-2 transition-colors ${on ? "border-forest bg-forest text-ivory" : "border-sage/30 !text-ink/60 hover:!text-ink"}`;

export function TagBar({ value, onPick, testid }) {
  const row = (list) => list.map((t) => <button key={t} onClick={() => onPick(t)} data-testid={`${testid}-${t.toLowerCase()}`} className={chip(value === t)}>{t}</button>);
  return (
    <div className="mb-8 space-y-2" data-testid={testid}>
      <div className="flex flex-wrap gap-2">{row(["All", ...SEVEN_P])}</div>
      <div className="flex flex-wrap gap-2">{row(LLL)}</div>
    </div>
  );
}

const CTA = {
  Properties: "will design your stay here, with every detail arranged.", Places: "will design your visit, with every detail arranged.",
  Passages: "will design your journey, with every detail arranged.", People: "will arrange your introduction, with every detail arranged.",
  Practitioners: "will arrange your introduction, with every detail arranged.", Products: "will recommend the right protocol for you.",
  Programmes: "will design your experience, with every detail arranged.",
};

export const byTag = (items, tag) => (tag === "All" ? items : items.filter((p) => tagsFor(p).includes(tag)));

export function PartnerCards({ items, testid, empty, film }) {
  const [pop, setPop] = useState(null);
  if (!items.length) return <p className="text-ink/50 text-sm font-headline italic" data-testid={`${testid}-empty`}>{empty}</p>;
  const open = (p) => setPop({ ...p, tag: p.line, blurb: `${p.name}, ${p.place}: ${p.line.toLowerCase()}, recommended by LUXEWELL. Tell us your pathway and Team LUXEWELL ${CTA[tagsFor(p)[0]]}` });
  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid={testid}>
        {items.map((p, i) => (
          <button key={p.name + p.place} onClick={() => open(p)} data-testid={`${testid}-card-${i}`} className="group text-left">
            <div className="gold-frame relative aspect-[4/3] overflow-hidden">
              <img src={p.img} alt={p.name} loading="lazy" className="muted-grade w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              {(film || p.star) && !p.name.startsWith("LUXEWELL") && <div className="absolute inset-0 bg-forest/25 pointer-events-none" />}
              {p.star && <span className="absolute top-2 left-2 eyebrow !text-[0.5rem] !text-gold bg-ivory/90 px-2 py-1" data-testid={`${testid}-star-${i}`}>★ Collection</span>}
            </div>
            <p className="font-headline text-lg leading-snug mt-3 group-hover:text-gold transition-colors">{p.name}</p>
            <p className="text-xs text-ink/50 mt-0.5">{p.place}</p>
          </button>
        ))}
      </div>
      <InfoPop item={pop} onClose={() => setPop(null)} />
    </>
  );
}
